import { render, staticRenderFns } from "./RecPage.vue?vue&type=template&id=ca1a28ea&scoped=true&"
import script from "./RecPage.vue?vue&type=script&lang=js&"
export * from "./RecPage.vue?vue&type=script&lang=js&"
import style0 from "./RecPage.vue?vue&type=style&index=0&id=ca1a28ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a28ea",
  null
  
)

export default component.exports